import { render, staticRenderFns } from "./PinnacleSportsHistory.vue?vue&type=template&id=15a37564&"
import script from "./PinnacleSportsHistory.vue?vue&type=script&lang=js&"
export * from "./PinnacleSportsHistory.vue?vue&type=script&lang=js&"
import style0 from "./PinnacleSportsHistory.vue?vue&type=style&index=0&id=15a37564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports